
import { mapGetters } from "vuex";
import { spacesToDashes } from "~/common/helpers";
import { resolveCategoryCanonicalUrl } from "~/common/seo/category-seo";
import { mdiCheck } from "@mdi/js";

export default {
  data() {
    return {
      gender:
        this.$route.params.gender ||
        this.$store.getters["global/getCurrentGender"] ||
        "female",
      district: "All districts",
      genders: [
        { title: this.$t("male"), value: "male" },
        { title: this.$t("female"), value: "female" },
        { title: this.$t("shemale"), value: "transgender" },
      ],

      mdiCheck,
    };
  },

  async fetch() {
    if (
      !this.$store.getters["category/getCategoryStructuredByGender"]?.female
        .length
    ) {
      await this.$store.dispatch("category/retrieveCategory");
    }

    if (!this.$store.getters["profiles/getFiltersList"]?.districts) {
      await this.$store.dispatch("profiles/retrieveFilters");
    }

    this.district = this.currentDistrict || "All districts";
  },

  head() {
    return {
      title: this.seoTexts?.title || this.$t("dashboard.categories"),
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.seoTexts?.description || "",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: this.canonicalUrl,
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      categoryStructuredByGender: "category/getCategoryStructuredByGender",
      seoTexts: "global/getSeoTexts",
      filtersList: "profiles/getFiltersList",
      currentCity: "global/getCurrentCity",
      currentDistrict: "global/getCurrentDistrict",
    }),

    selectedDistrictUrl() {
      if (!this.district || this.district == "All districts") {
        return `/${spacesToDashes(this.currentCity.name)}`;
      }

      return `/${spacesToDashes(this.currentCity.name)}-${spacesToDashes(
        this.district
      )}`;
    },

    canonicalUrl() {
      return resolveCategoryCanonicalUrl({
        baseUrlApp: this.$config.baseUrlApp,
        cityName: this.currentCity.name,
        gender: this.gender,
      });
    },

    h1() {
      return this.seoTexts?.h1 || this.$t("dashboard.categories");
    },

    categoriesToDisplay() {
      return this.categoryStructuredByGender
        ? this.categoryStructuredByGender[this.gender]
        : [];
    },

    uiGender() {
      return this.genders?.find((g) => g.value === this.gender).title || "";
    },

    breadcrumbsItems() {
      return [
        {
          href: "/",
          text: this.$t("nav.home"),
          pos: 1,
          disabled: false,
        },
        {
          href: `/categories/${this.gender}`,
          text: `${this.$t("dashboard.categories")} ${this.uiGender}`,
          pos: 3,
          disabled: false,
        },
      ];
    },

    allDistrictsOption() {
      return {
        city: this.currentCity,
        city_id: this.currentCity.id,
        id: 0,
        title: "All districts",
      };
    },

    districts() {
      return [
        this.allDistrictsOption,
        ...(this.filtersList.districts || []).filter(
          (item) => item.city_id === this.currentCity.id
        ),
      ];
    },

    locationsCategories() {
      const structuresDistrictsCategories = {};

      for (let i = 0; i < this.districts.length; i++) {
        const district = this.districts[i];
        if (!structuresDistrictsCategories[district.city_id]) {
          structuresDistrictsCategories[district.city_id] = {
            title: `browse ${this.gender} from ${district.city.title} districts`,
            list: [],
          };
        }

        structuresDistrictsCategories[district.city_id].list.push({
          title: district.title,
          url: this.districtUrl(district),
        });
      }

      return Object.values(structuresDistrictsCategories);
    },
  },

  watch: {
    // change route on gender change
    gender(val) {
      this.$router.push(`/categories/${val}`);
    },
  },

  methods: {
    districtUrl(district) {
      const cityUrl = spacesToDashes(
        district?.city?.title || district?.city?.name
      );
      if (district.title == "All districts") {
        return "/" + cityUrl + "/" + this.gender;
      }
      const districtUrl = "-" + spacesToDashes(district.title);
      return "/" + cityUrl + districtUrl + "/" + this.gender;
    },
  },
};
